import { makeStub, injectScript, createUspStub } from "./tcfv2.js";
import configUtilities from "../../../scriptsCore/js/configUtilities.js";
import { updateGdprApplies } from "../staticConsent.js";

// only works for less than 4 levels
// a.b.co.uk -> 3, a.b.com -> 2, a.com -> 2
const stripSubdomain = (hostname) =>
  hostname
    .split(".")
    .slice(-(hostname.substr(-6) === ".co.uk" ? 3 : 2))
    .join(".");

const getHost = () => {
  const hostname = window.location.hostname;
  return configUtilities.getConfigParam("cmpIncludeSubdomains")
    ? stripSubdomain(hostname)
    : hostname;
};

/**
 * Stores CMP state promises in order to reuse them
 * {
 *   ready: <Promise>,    // cmp is fully loaded
 *   accepted: <Promise>, // user clicked save consent button first time
 *   ui: <Promise>,       // cmp ui is shown first time
 * }
 */
function setCmpState(state) {
  window.TMConsent = window.TMConsent || {};
  window.TMConsent.cmpState = state;
}

export function getCmpPromise(type) {
  const cmpState = window?.TMConsent?.cmpState || {};
  return cmpState[type] || Promise.reject();
}

/**
 * Registers CMP event listener and creates state promises
 */
export function listenToCMPState() {
  // listen to any of listed events below to create corresponding promise
  const config = {
    ready: ["useractioncomplete", "tcloaded"],
    accepted: ["useractioncomplete"],
    ui: ["cmpuishown"],
  };

  const cmpState = Object.keys(config).reduce((obj, key) => {
    const eventList = config[key];
    obj[key] = new Promise((resolve) => {
      const listener = (tcData, success) => {
        if (!success) return;
        if (tcData.gdprApplies != null) {
          updateGdprApplies(tcData.gdprApplies); // update before we resolve promise
        }
        if (eventList.includes(tcData.eventStatus)) {
          resolve(tcData);
        }
      };
      window.__tcfapi && window.__tcfapi("addEventListener", 2, listener);
    });

    return obj;
  }, {});

  setCmpState(cmpState);
}

/**
 * Returns a promize for CMP to be fully loaded (once).
 * Triggers appropriate events if called.
 */
export function cmpIsReady() {
  return getCmpPromise("ready");
}

/**
 * Returns a promize for user to confirm consent (once). This may never happen!
 * Triggers appropriate events if called.
 */
export function userSavedConsent() {
  return getCmpPromise("accepted");
}

export function init() {
  // ignore escenic preview url's
  const cmpIsDisabled = /\.ece$/.test(window.location.pathname);
  if (cmpIsDisabled) {
    return;
  }

  injectScript(getHost());
  makeStub();
  createUspStub();
  listenToCMPState();
}
